/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicKeyCredentialParams } from './PublicKeyCredentialParams';
import {
    PublicKeyCredentialParamsFromJSON,
    PublicKeyCredentialParamsFromJSONTyped,
    PublicKeyCredentialParamsToJSON,
    PublicKeyCredentialParamsToJSONTyped,
} from './PublicKeyCredentialParams';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
    CredentialTypeToJSONTyped,
} from './CredentialType';

/**
 * 
 * @export
 * @interface PublicKeyCredential
 */
export interface PublicKeyCredential {
    /**
     * 
     * @type {CredentialType}
     * @memberof PublicKeyCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PublicKeyCredentialParams}
     * @memberof PublicKeyCredential
     */
    params: PublicKeyCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof PublicKeyCredential
     */
    label?: string;
}



/**
 * Check if a given object implements the PublicKeyCredential interface.
 */
export function instanceOfPublicKeyCredential(value: object): value is PublicKeyCredential {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function PublicKeyCredentialFromJSON(json: any): PublicKeyCredential {
    return PublicKeyCredentialFromJSONTyped(json, false);
}

export function PublicKeyCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicKeyCredential {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CredentialTypeFromJSON(json['type']),
        'params': PublicKeyCredentialParamsFromJSON(json['params']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PublicKeyCredentialToJSON(json: any): PublicKeyCredential {
    return PublicKeyCredentialToJSONTyped(json, false);
}

export function PublicKeyCredentialToJSONTyped(value?: PublicKeyCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CredentialTypeToJSON(value['type']),
        'params': PublicKeyCredentialParamsToJSON(value['params']),
        'label': value['label'],
    };
}

